import MDPreview, { MarkdownPreviewProps as MDPreviewProps } from "@uiw/react-markdown-preview"
import rehypeSlug from "rehype-slug"
import remarkGfm from "remark-gfm"

const MarkdownPreview = (props: MDPreviewProps) => {
  return (
    <MDPreview
      {...props}
      wrapperElement={{ "data-color-mode": "light" }}
      rehypePlugins={[
        rehypeSlug, // enables links (scroll to element)
      ]}
      remarkPlugins={[
        remarkGfm, // GitHub-specific extension: tables, strikethrough, tasklists, and literal URLs.
      ]}
    />
  )
}

export default MarkdownPreview
